import { useState, type JSX } from "react";
import styles from "./LiveShortInterest.module.scss";
import Image from "next/legacy/image";
import dynamic from "next/dynamic";
import { DataGrid } from "../data-grid/DataGrid";
import { Stock } from "@/models/stock";
import { getIBKR } from "@/controllers/stock-shorts";
import Module from "@/components/module/Module";
import StockLiveShortInterestData from "../stock-live-short-interest-data/StockLiveShortInterestData";
import { Box, useMediaQuery } from "@mui/material";

const IBKRSharesChart = dynamic(() => import("@/components/ibkr-shares-chart/IBKRSharesChart"), { ssr: false });

type Props = {
    stock: Stock;
};

const LiveShortInterest = ({ stock }: Props) => {
    const [regshoFlag, setRegshoFlag] = useState<false | JSX.Element>(false);
    const isMobile = useMediaQuery("(max-width: 1919px)");
    const [obfuscateFlag, setObfuscateFlag] = useState<boolean>(false);
    return (
        <div className={styles.LiveShortInterest}>
            <div className={styles.chart}>
                <Module title={`Live Short Interest Data`} help={{ moduleId: "live_data", modulePage: "V2_stock_short_interest" }} subHeader={<>{regshoFlag}</>}>
                    <StockLiveShortInterestData stock={stock} setModuleHeader={setRegshoFlag} page={"live-SI"} setObfuscated={setObfuscateFlag} />
                </Module>
            </div>
            <div className={styles["interactive-brokers"]}>
                <Module
                    title="Interactive Brokers Short Availability"
                    help={{ moduleId: `short_sharestable_availability`, modulePage: "V2_stock_short_interest" }}
                    settingsComponent={
                        <Box sx={{ display: "flex" }}>
                            <Image unoptimized src={`/assets/${isMobile ? "ortex-icon.png" : "ortex-logo-h.png"}`} alt="ortex-logo" width={isMobile ? 20 : 120} height={isMobile ? 20 : 25} />
                        </Box>
                    }
                    allowFullscreen
                >
                    <DataGrid fetcher={getIBKR} key="ibkr" regionId={stock.tradingitem_id} tableId="ibkr" />
                </Module>
                <Module
                    title="Interactive Brokers Short Shares"
                    help={{ moduleId: `short_sharestable_shares`, modulePage: "V2_stock_short_interest" }}
                    settingsComponent={
                        <Box sx={{ display: "flex" }}>
                            <Image unoptimized src={`/assets/${isMobile ? "ortex-icon.png" : "ortex-logo-h.png"}`} alt="ortex-logo" width={isMobile ? 20 : 120} height={isMobile ? 20 : 25} />
                        </Box>
                    }
                    allowFullscreen
                >
                    <IBKRSharesChart stock={stock} borderRadius obfuscated={obfuscateFlag} />
                </Module>
            </div>
        </div>
    );
};

export default LiveShortInterest;
